const cloneMixin = {
    methods: {
        clone(Obj) {
            var buf;
            if (Obj instanceof Array) {
                buf = [];
                var i = Obj.length;
                while (i--) {
                    buf[i] = this.clone(Obj[i]);
                }
                return buf;
            } else if (Obj instanceof Object) {
                buf = {};
                for (var k in Obj) {
                    buf[k] = this.clone(Obj[k]);
                }
                return buf;
            } else {
                return Obj;
            }
        }
    }
}
export default cloneMixin